import { styled } from '@mui/material';

const Loader = styled('div')({
  width: '180px',
  height: '10px',
  borderRadius: '5px',
  background:
    'linear-gradient(90deg, #0000 ,orange) left -50px top 0/50px 20px no-repeat lightblue',
  animation: 'loader 1s infinite linear',
  '@keyframes loader': {
    '100%': { backgroundPosition: 'right -50px top 0' },
  },
});

export default Loader;
